import Box from '@mui/material/Box';
import React from 'react';

import {
  FormControlLabel,
  FormControlLabelPlacementProps,
} from '../../../../../components/atoms/FormControlLabel';
import { SectionLabel } from '../../../../../components/atoms/SectionLabel';
import { Switch } from '../../../../../components/atoms/Switch';
import { Typography, TypographyVariantProps } from '../../../../../components/atoms/Typography';
import { toggleFieldSx } from '../../../../../configs/detailPanelStyles';

export interface FreightDeliveryOptionsProps {
  isSafeDrop?: boolean;
  onSafeDropChange: (checked: boolean) => void;
  isAuthToLeave?: boolean;
  onAuthToLeaveChange: (checked: boolean) => void;
  isCustomAddress?: boolean;
  onCustomAddressChange: (checked: boolean) => void;
}

const OPTION_LABEL_SX = { minWidth: 160 };

/**
 * The three delivery instructions that ride with a freight order. Toggles
 * rather than checkboxes: each is an independent on/off setting on the order,
 * which is what the rest of the app uses a switch for.
 */
export const FreightDeliveryOptions: React.FC<FreightDeliveryOptionsProps> = ({
  isSafeDrop,
  onSafeDropChange,
  isAuthToLeave,
  onAuthToLeaveChange,
  isCustomAddress,
  onCustomAddressChange,
}) => {
  const options = [
    { label: 'Safe Drop', checked: !!isSafeDrop, onChange: onSafeDropChange },
    { label: 'Authority to Leave', checked: !!isAuthToLeave, onChange: onAuthToLeaveChange },
    { label: 'Custom Address', checked: !!isCustomAddress, onChange: onCustomAddressChange },
  ];

  return (
    <Box>
      <SectionLabel>Delivery Options</SectionLabel>
      <Box sx={{ ...toggleFieldSx, display: 'flex', flexWrap: 'wrap', gap: 2 }}>
        {options.map((option) => (
          <Box key={option.label} sx={OPTION_LABEL_SX}>
            <FormControlLabel
              labelPlacement={FormControlLabelPlacementProps.End}
              control={
                <Switch
                  checked={option.checked}
                  onChange={(event) => option.onChange(event.target.checked)}
                  ariaLabel={option.label}
                />
              }
              label={<Typography variant={TypographyVariantProps.Body2}>{option.label}</Typography>}
            />
          </Box>
        ))}
      </Box>
    </Box>
  );
};
